import axios from "axios";

const isDebug = process.env.REACT_APP_ENV === "DEBUG";
const isLocal = process.env.REACT_APP_ENV === "LOCAL";

const BASE_API_URL = isLocal
  ? "http://localhost:8080/api/data-center"
  : isDebug
  ? "https://dev.fortune.leinotek.com/api/data-center"
  : "https://fortune.leinotek.com/api/data-center";

class DataCenterService {
  trackSimpleBaiFlow() {
    if (isLocal || isDebug) {
      return;
    }

    return axios.post(BASE_API_URL + "/track-simplebai-flow");
  }
}

const dataCenterService = new DataCenterService();
export default dataCenterService;
